module.exports = __webpack_public_path__ + "img/Kc.bc9e8853.png";